/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actiontypes from './actiontypes';
const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.AR_ALL_TBL_DATA:
      return { ...state, ar_tbl: action.payload };
    case actiontypes.AR_ALL_FLD_DATA:
      return { ...state, qtr_val: action.payload };
    case actiontypes.AR_SGL_TBL_DATA:
      return { ...state, sgl_tbl: action.payload };
    case actiontypes.AR_SUMMERY_MFG_ALL_FIELD_CLEAR_REDUX:
      return {};
    default:
      return state;
  }
};

export default reducer;
